/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apr_S1Inputs */

const en_mk_tut_apr_s1 = /** @type {(inputs: Mk_Tut_Apr_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you create the issue, say it plainly: “draft the message, then request approval before sending”.`)
};

const id_mk_tut_apr_s1 = /** @type {(inputs: Mk_Tut_Apr_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat membuat issue, tulis instruksi yang jelas: "susun pesannya, lalu ajukan persetujuan sebelum dikirim".`)
};

/**
* | output |
* | --- |
* | "When you create the issue, say it plainly: “draft the message, then request approval before sending”." |
*
* @param {Mk_Tut_Apr_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apr_s1 = /** @type {((inputs?: Mk_Tut_Apr_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apr_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apr_s1(inputs)
	return en_mk_tut_apr_s1(inputs)
});